import Input from '../../../ui/input';
import Switch from '../../../ui/switch';
import Text from '../../../ui/text';
import { useFormContext } from "react-hook-form";

function AddressInfo() {
  const { 
    register,
    control,
    formState: { errors },
  } = useFormContext();
  return (
    <section className="w-full">
      <h2 className="text-2xl font-semibold leading-none opacity-[var(--sds-size-stroke-border)] text-sky-950">
        <Text>Permanent Address</Text>
      </h2>
      <p className="text-base leading-10 text-zinc-600 max-md:max-w-full">
        <Text>(PO Box only allowed if experiencing homelessness)</Text>
      </p>
      <div className='w-full flex flex-col justify-start items-start mt-5'>
        <Switch name='experiencingHomelessness' control={control}>
          <Text>Experiencing Homelessness</Text>
        </Switch>
      </div>
      <div className="grid grid-cols-12 gap-5 mt-5">
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='addressLine1'>Permanent Address (Line 1)</Text>
          <Input
            {...register('addressLine1')}
            size='sm'
            label={<Text>Permanent Address (Line 1)</Text>}
            placeholder="-"
            errorMessage={errors?.addressLine1?.message || null}
            isInvalid={errors?.addressLine1 ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-6 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='addressLine2'>Address (Line 2)</Text>
          <Input
            {...register('addressLine2')}
            size='sm'
            label={<Text>Last Name</Text>}
            placeholder="-"
            errorMessage={errors?.addressLine2?.message || null}
            isInvalid={errors?.addressLine2 ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='city'>City *</Text>
          <Input
            {...register('city')}
            size='sm'
            label={<Text>City</Text>}
            placeholder="-"
            errorMessage={errors?.city?.message || null}
            isInvalid={errors?.city ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='state'>State *</Text>
          <Input
            {...register('state')}
            size='sm'
            label={<Text>State</Text>}
            placeholder="-"
            errorMessage={errors?.state?.message || null}
            isInvalid={errors?.state ? true : false}
          />
        </div>
        <div className='col-span-12 sm:col-span-4 flex flex-col justify-start items-start'>
          <Text type='label' htmlFor='zipCode'>ZIP Code *</Text>
          <Input
            {...register('zipCode')}
            size='sm'
            label={<Text>ZIP Code</Text>}
            placeholder="-"
            errorMessage={errors?.zipCode?.message || null}
            isInvalid={errors?.zipCode ? true : false}
          />
        </div>
      </div>
    </section>
  );
}

export default AddressInfo;